/**
 * Detect environment for public config (`config.<env>.json`) and UI behavior.
 *
 * **Hostname wins** for staging vs production in the browser so the same production
 * build artifact can be deployed to staging or prod and still load the right config
 * (`static.prhs-stg.*` → staging, not `config.production.json`).
 *
 * On localhost, `REACT_APP_ENV` may override (e.g. test staging locally). When
 * `window` is unavailable (SSR/tests), fall back to `REACT_APP_ENV` then `production`.
 */
export function getRuntimeEnv() {
  if (typeof window !== 'undefined' && window.location?.hostname) {
    const host = (window.location.hostname || '').toLowerCase();
    if (host === 'localhost' || host.startsWith('127.')) {
      return process.env.REACT_APP_ENV || 'development';
    }
    if (host.includes('stg') || host.includes('staging')) {
      return 'staging';
    }
    return 'production';
  }
  if (process.env.REACT_APP_ENV) return process.env.REACT_APP_ENV;
  return 'production';
}
